import { useEffect } from 'react';

import * as Sentry from '@sentry/react';
import { useRouteError } from 'react-router-dom';

import { EchoServerError } from '../../features/echo';
import { PartialErrorFallback } from '../error-fallbacks';

export const ErrorElement = ({ feature, owner }: { feature?: string; owner?: string }) => {
  const error = useRouteError();

  useEffect(() => {
    if (error instanceof EchoServerError) return;

    Sentry.withScope(scope => {
      if (feature) scope.setTag('feature', feature);
      if (owner) scope.setTag('owner', owner);
      Sentry.captureException(error);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <PartialErrorFallback />;
};
